const Loading = () => {
  return (
    <div className="loading">
      <span className="spinner"></span>
    </div>
  );
};

export default Loading;
